/**
 * Total units in cart: one per service line + sum of product quantities.
 */
export function getCartItemCount(
  services: unknown[] | undefined | null,
  products: { qty?: number }[] | undefined | null
): number {
  const serviceLines = services?.length ?? 0;
  const list = products ?? [];
  const productUnits = list.reduce((sum, item) => {
    const q = Number(item?.qty);
    return sum + (Number.isFinite(q) && q > 0 ? q : 1);
  }, 0);
  return serviceLines + productUnits;
}
